export default {"src":"https://fishbrain.com/_next/static/media/snakehead.a5f6908c.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};